import type { FaireProductEntity } from "../../entity_types/product";

export const atc_updated_moma_7: FaireProductEntity = {
  token: "atc_updated_moma_7",
  type: "product",
  name: "Glass Teapot with Infuser",
  brandName: "MoMA Design Store",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/e77bd1611c62bce6b10680bcd2f4d7e1f09e8cd3bbf3acacf00225ca7c978e89.webp",
  priceDollars: 42,
  msrpDollars: 52,
  description: "Clear glass teapot with colorful lid.",
  tags: ["home", "design"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
